import React, { useContext, useState } from "react";
import ReactPlayer from "react-player";
import { s3_cdn } from "../../utils";

import {
  getArticleBySlug,
  getArticleBySlugReset,
} from "../../action/getArticleBySlugAction";
import HeaderContext from "../../context/HeaderContext";
// console.log("getArticleBySlug", getArticleBySlug.data)
function VideoArticle(props) {
  const { setTitle } = useContext(HeaderContext);
  setTitle("Video");
  const { getArticleBySlug, getArticleBySlugReset, getArticleBySlugState } =
    props;
  return (
    <ReactPlayer
      width="100%"
      style={{ paddingLeft: "8px" }}
      url={props.ArticleData.video_link}
    />
  );
}

export default VideoArticle;
